









































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";
import { bus } from "../../main";
import * as temp from "../../_store/temp.module";

@Component
export default class ColloquioCVCreate extends Vue {
  private allieviList: any;
  private aziendeList: any;
  private tempAllieviList: any;
  private tempAziendeList: any;
  private allievoSelezionato: number;
  private aziendaSelezionata: number;
  private isLoadingAllievi: boolean;
  private isLoadingAziende: boolean;
  private searchAllievi: boolean | null;
  private searchAziende: boolean | null;
  private turno: number;
  private area: any;
  private listaAree: any;
  private listaTurni: any;

  private allievoRules: [boolean | string];
  private aziendaRules: [boolean | string];
  private turnoRules: [boolean | string];

  private articolazioneAllievo: string;

  private disabledSelectionAllievo: boolean;
  private disabledSelection: boolean;

  constructor() {
    super();
    this.allieviList = [];
    this.aziendeList = [];
    this.listaAree = [];
    this.listaTurni = [];
    this.tempAllieviList = [];
    this.tempAziendeList = [];
    this.allievoSelezionato = 0;
    this.aziendaSelezionata = 0;
    this.isLoadingAllievi = false;
    this.isLoadingAziende = false;
    this.searchAllievi = null;
    this.searchAziende = null;
    this.turno = 0;
    this.area = 0;

    this.allievoRules = [true];
    this.aziendaRules = [true];
    this.turnoRules = [true];

    this.articolazioneAllievo = "";

    this.disabledSelectionAllievo = true;
    this.disabledSelection = true;
  }

  @Watch("searchAllievi")
  onAllievoChanged(value: string) {
    if (this.allieviList.length > 0) return;
    this.isLoadingAllievi = true;
    data
      .dispatchStatiList(this["$store"])
      .then(response => {
        if (response !== null) {
          this.allieviList = response;
        }
      })
      .catch(error => {
        bus.$emit(
          "errorOperation",
          "Errore nel caricamento della lista allievi"
        );
      })
      .finally(() => (this.isLoadingAllievi = false));
  }

  @Watch("searchAziende")
  onAziendaChanged(value: string) {
    if (this.aziendeList.length > 0) return;
    this.isLoadingAziende = true;
    data
      .dispatchStatiList(this["$store"])
      .then(response => {
        if (response !== null) {
          this.aziendeList = response;
        }
      })
      .catch(error => {
        bus.$emit(
          "errorOperation",
          "Errore nel caricamento della lista allievi"
        );
      })
      .finally(() => (this.isLoadingAziende = false));
  }

  @Watch("allievoSelezionato")
  onAllievoSelezionatoChange(value: number) {
    var tempArticolazione: string = "";
    for (let i = 0; i < this.allieviList.length; i++) {
      if (this.allieviList[i].idAllievo === this.allievoSelezionato) {
        tempArticolazione = this.allieviList[i].idArticolazioneAllievo;
      }
    }
    this.articolazioneAllievo = tempArticolazione;
  }

  @Watch("articolazioneAllievo")
  onArticolazioneAllievoChange(value: number) {
    var tmpArray: any = [];

    for (let i = 0; i < this.aziendeList.length; i++) {
      if (
        this.aziendeList[i].idArticolazioneAzienda === this.articolazioneAllievo && this.aziendeList[i].idArea === this.area
      ) {
        tmpArray.push(this.aziendeList[i]);
      }
    }

    this.tempAziendeList = tmpArray;
    this.disabledSelection = false;
  }

  @Watch("area")
  onAreaChange(value: number){
    var tmpArray: any = []
    for(let i = 0; i < this.allieviList.length; i++){
      if (this.allieviList[i].idArea === this.area){
        tmpArray.push(this.allieviList[i])
      }
    }
    this.tempAllieviList = tmpArray;
    this.disabledSelectionAllievo = false;
  }

  close() {
    this.tempAziendeList = [];
    this.allievoSelezionato = 0;
    this.aziendaSelezionata = 0;
    this.isLoadingAllievi = false;
    this.isLoadingAziende = false;
    this.searchAllievi = null;
    this.searchAziende = null;
    this.turno = 0;
    this.area = 0;

    this.allievoRules = [true];
    this.aziendaRules = [true];
    this.turnoRules = [true];

    this.articolazioneAllievo = "";

    this.disabledSelection = true;
    this.disabledSelectionAllievo = true;
    bus.$emit("closeCreateDialog");
  }

  validazioneAllievo() {
    if (this.allievoSelezionato !== 0) {
      this.allievoRules = [true];
    } else {
      this.allievoRules = ["Specificare Allievo"];
    }
  }
  validazionneAzienda() {
    if (this.aziendaSelezionata !== 0) {
      this.aziendaRules = [true];
    } else {
      this.aziendaRules = ["Specificare Azienda"];
    }
  }
  validazioneTurno() {
    if (this.turno !== 0) {
      this.turnoRules = [true];
    } else {
      this.turnoRules = ["Specificare Turno"];
    }
  }

  loadAree() {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var instituteInfo = user.readInstituteInfo(this["$store"]);
    var payload = {
      idIstituto: instituteInfo.id
    };
    data
      .dispatchAreeIstituto(this["$store"], payload)
      .then(resp => {
        this.listaAree = resp;
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  loadTurni() {
    var instituteInfo = user.readInstituteInfo(this["$store"]);
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var payload = {
      idIstituto: instituteInfo.id,
      idAnnoScolastico: idAnnoScolastico
    };
    data
      .dispatchTurniColloquiCV(this["$store"], payload)
      .then(result => {
        this.listaTurni = result;
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }

  async executeTest() {
    this.validazioneAllievo();
    this.validazionneAzienda();
    this.validazioneTurno();
  }

  save() {
    var instituteInfo = user.readInstituteInfo(this["$store"]);
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    this.executeTest().then(() => {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        var payload = {
          idAllievo: this.allievoSelezionato,
          idAzienda: this.aziendaSelezionata,
          idIstituto: instituteInfo.id,
          idArticolazione: this.articolazioneAllievo,
          idAnnoScolastico: idAnnoScolastico,
          nTurno: this.turno
        };
        user
          .dispatchRegisterSchedule(this["$store"], payload)
          .then(() => {
            bus.$emit("successfullOperation", "Colloquio creato con successo");
            // bus.$emit("loadColloquiList");
            bus.$emit("createdColloquio");
            this.close();
          })
          .catch(error => {
            if (error.response.status === 403) {
              bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
              this["$router"].push("/login");
            } else {
              bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
            }
          });
      } else {
        bus.$emit("errorOperation", "Valori errati e/o mancanti");
      }
    });
  }

  created() {
    var instituteInfo = user.readInstituteInfo(this["$store"]);
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var payload = {
      idIstituto: instituteInfo.id,
      idAnnoScolastico: idAnnoScolastico
    };
    this.loadAree();
    this.loadTurni();
    data
      .dispatchAllieviColloquiCV(this["$store"], payload)
      .then(result => {
        this.allieviList = result;
        data.dispatchAziendeColloquiCV(this["$store"], payload).then(resp => {
          this.aziendeList = resp;
        });
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
        }
      });
  }
}
